// The customer collection protocol: one list of questions, read by the intake
// form, the profile card, the directory's protocol dialog and the dispatch
// email, so no two of them can word a question differently or drop one.
//
// Plain ESM with no imports so the same source serves Node and Vite.

export const PROTOCOL_ITEMS = [
  {
    field: 'secondCollectionOutOfTemp',
    label: 'Second collection allowed if out of temp',
  },
  {
    field: 'secondCollectionTampering',
    label: 'Second collection allowed if suspected tampering',
  },
  {
    field: 'immediateObservation',
    label: 'Immediate observation if suspected tampering or out of temp',
  },
  {
    field: 'confirmNonNegativeRapids',
    label: 'Confirmations on non-negative rapids',
  },
  {
    field: 'confirmNonNegativeNonDotBats',
    label: 'Confirmation on non-negative non-DOT BATs',
  },
  {
    field: 'standardDotProtocol',
    label: 'Standard DOT protocol on all tests',
  },
]

// The protocol as plain text lines, for places with no markup: the dispatch
// email, and anywhere else the answers travel outside the app.
export function protocolAsText(customer) {
  const lines = PROTOCOL_ITEMS.map(
    (item) => `- ${item.label}: ${customer[item.field] ? 'Yes' : 'No'}`,
  )
  lines.push(`- Customer-specific protocols: ${customer.customerProtocols?.trim() || 'None'}`)
  return lines.join('\n')
}
